<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="pub-video-page">
    <Header />
    <SideBar :current="'video'" />

    <div class="video-upload-select-wrap" v-if="showVideoSelectWrap">
      <div class="video-type-nav">
        <div class="second-nav-list">
          <a href="/publish" class="item focus"> 发布视频 </a>
          <a href="/video/-1" class="item"> 视频管理 </a>
        </div>
      </div>
      <div class="video-uploader-box" v-loading="loading">
        <el-upload
          ref="upload"
          class="m-uploader"
          multiple
          :show-file-list="false"
          :before-upload="handleBeforeUpload"
          action=""
          drag
          :accept="fileAccept"
          :auto-upload="false"
          :on-change="onVideoFileSelected"
        >
          <img class="el-icon-upload" src="@/assets/images/upload-icon.png" />
          <div class="el-upload__text">
            将文件拖拽到此区域也可上传<br /><span class="multi-tip"
              >支持一次选择多条视频，按每5条排队上传</span
            >
            <el-button class="upload-btn">点击上传</el-button>
          </div>
        </el-upload>
      </div>
      <ul class="video-upload-tips">
        <li>
          <svg class="icon my-icon" aria-hidden="true">
            <use xlink:href="#icon-tupian"></use>
          </svg>
          <span
            >推荐尺寸<i>视频封装格式为:</i><i>MP4、MOV、AVI</i
            ><i>视频比例横屏16:9 竖屏9:16</i></span
          >
        </li>
        <li>
          <svg class="icon my-icon" aria-hidden="true">
            <use xlink:href="#icon-wangye"></use>
          </svg>
          <span
            >推荐分辨率<i>1280*720(720P)</i><i>1980*1020(1080P)</i
            ><i>帧率30~60fps</i></span
          >
        </li>
        <li>
          <svg class="icon my-icon" aria-hidden="true">
            <use xlink:href="#icon-shipin"></use>
          </svg>
          <span>视频大小<i>≤5G</i></span>
        </li>
      </ul>
    </div>

    <!-- 单视频 -->
    <div
      class="video-edit-wrap single"
      v-if="!showVideoSelectWrap && !isMultiple"
    >
      <div class="video-type-nav">
        <div class="second-nav-list">
          <a href="/publish" class="item focus"> 发布视频 </a>
          <a href="/video/-1" class="item"> 视频管理 </a>
        </div>
      </div>
      <h2 class="sub-page-title">{{ isEdit ? '编辑' : '发布' }}视频</h2>
      <el-form class="video-edit-form" :model="formData" ref="formDom">
        <!-- 上传 -->
        <div
          class="video-edit-module largest video-upload-module"
          v-show="!isEdit"
        >
          <h4 class="m-title">文件上传</h4>
          <div class="m-ctnt pb0">
            <div class="video-upload-progress">
              <span class="video-name">{{ uploadFile.name }}</span>
              <span class="progress-info">
                <i class="percent">{{ uploadProgressPercent }}%</i>
                <!-- <i class="time" v-if="uploadProgressPercent < 100 && !hideUploadNeedTime && uploadNeedTime"
                  >剩余{{ uploadNeedTime }}S</i
                > -->
              </span>
              <div class="progress-box">
                <div
                  class="progress-bar"
                  :style="{ width: uploadProgressPercent + '%' }"
                ></div>
              </div>
              <div class="other-info">
                <span
                  class="status-text"
                  :class="{ success: uploadStatusText == '上传成功' }"
                  >{{ uploadStatusText }}</span
                >
                <span class="upload-text-btn">
                  <label for="uploadVideoSelectText">重新上传</label>
                  <input
                    id="uploadVideoSelectText"
                    ref="uploadVideoInput"
                    :accept="fileAccept"
                    type="file"
                    @change="uploadVideoFileChange"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="video-edit-module preview-module"
          v-loading="posting"
          v-if="isEdit && formData"
        >
          <h4 class="m-title">视频预览</h4>
          <div class="preview-warp" @click="previewVideo()">
            <img
              v-if="formData?.videoResp?.videoCover"
              :src="formData?.videoResp?.videoCover"
              alt=""
            />
            <img v-else alt="" src="@/assets/images/no-cover.png" />
            <div class="mask"></div>
            <div class="play-icon"></div>
          </div>
        </div>

        <div class="video-edit-module" v-loading="posting">
          <h4 class="m-title">视频信息</h4>
          <div class="m-ctnt">
            <el-form-item
              label="标题"
              prop="title"
              :rules="[
                { validator: formRules.textLen(5, 30), trigger: 'change' },
                { required: true, message: '必须填写' },
              ]"
            >
              <el-input
                class="m-input count"
                maxlength="30"
                v-model="formData.title"
                placeholder="视频标题 5-30个字符"
              ></el-input>
              <span class="input-count din">{{
                formData.title | textCount(30)
              }}</span>
            </el-form-item>

            <el-form-item label="关联话题">
              <TopicSelect
                v-model="formData.topics"
                :options="topicList"
                @add="insertPublishTopic"
              />
            </el-form-item>
            <el-form-item
              class="textarea-input"
              label="正文"
              prop="content"
              :rules="[
                { validator: formRules.textLen(0, 500), trigger: 'change' },
              ]"
            >
              <div
                id="editable-content"
                ref="editRef"
                className="feed-edit-wrap"
                contentEditable="true"
                @input="handleInput"
                @blur="handleOnBlur"
                v-html="htmlStr"
              ></div>
              <p class="txt-num" :class="overLimit ? 'c-red' : ''">
                {{ contentLen }}/{{ totolTxtNum }}
              </p>
            </el-form-item>

            <el-form-item label="投稿活动">
              <el-select
                v-model="formData.activityId"
                placeholder="请选择投稿活动"
                @change="handleSelectActive"
              >
                <el-option
                  v-for="item in activityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="关联文物" class="collection-form-item">
              <el-select
                v-model="formData.collectionIds"
                placeholder="请选择关联文物"
                multiple
                filterable
                remote
                popper-class="collection-dropdown"
                :remote-method="fetchCollection"
                @visible-change="onCollectionVisible"
              >
                <el-option
                  v-for="item in collectionList"
                  :key="item.collectInfo.id"
                  :label="item.collectInfo.title"
                  :value="item.collectInfo.id"
                  class="collection-option"
                >
                  <div class="item">
                    <img :src="item?.collectInfo?.image?.url" class="image" />
                    <div class="info">
                      <a
                        class="name text-overflow-2"
                        :title="item.collectInfo.title"
                        :alt="item.collectInfo.title"
                        >{{ item.collectInfo.title }}</a
                      >
                    </div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="内容标签">
              <ContentTagSelect v-model="formData.contentTags" />
            </el-form-item>

            <el-form-item label="封面" required>
              <el-row>
                <el-col :span="10" class="upload-img-item">
                  <div class="upload-img-wrap vertical">
                    <ImgCropUpload
                      :src="formData.verticalImg"
                      :crop="true"
                      :cropWidth="342"
                      :cropHeight="478"
                      :cropList="true"
                      :imgs="snapshotVideoList"
                      @success="imgUploadSuccess($event, 'verticalImg')"
                    />
                  </div>
                  <span class="tip-text mt6"
                    >上传视频封面（<i>342x478px</i>）</span
                  >
                  <el-form-item
                    class="hidden"
                    prop="verticalImg"
                    :rules="[{ required: true, message: '请上传视频封面' }]"
                  >
                    <el-input
                      type="hidden"
                      v-model="formData.verticalImg"
                      placeholder="请上传视频封面"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>

            <el-form-item
              v-if="isSupplyText"
              label="补充文稿"
              prop="supplyText"
              :rules="[
                { validator: formRules.textLen(5, 3000), trigger: 'change' },
                { required: true, message: '必须填写' },
              ]"
              class="textarea-input supplytext"
            >
              <el-input
                type="textarea"
                :rows="5"
                class="m-input count"
                maxlength="3000"
                v-model="formData.supplyText"
                placeholder="补充文稿 5-3000个字符"
              ></el-input>
              <span class="input-count din">{{
                formData.supplyText | textCount(3000)
              }}</span>
              <span class="tips">仅供后台收集需要，不向公众展示</span>
            </el-form-item>

            <el-form-item label="AI创作者声明" prop="isUseAI">
              <el-checkbox class="m-checkbox" v-model="formData.isUseAI"
                >视频创作中使用了AI工具，添加AI内容生产标识</el-checkbox
              >
            </el-form-item>

            <el-form-item
              key="agree"
              label=""
              prop="checked"
              class="mb-100"
              :rules="[
                { required: true, message: '请同意相关协议' },
                {
                  validator: formRules.isTrue,
                  message: '请同意相关协议',
                  trigger: 'change',
                },
              ]"
            >
              <div class="agree-protocol">
                <el-checkbox class="m-checkbox" v-model="formData.checked"
                  >我已阅读并接受</el-checkbox
                ><a
                  target="_blank"
                  href="https://omgotv.mgtv.com/protocol/SH_creator_covenant"
                  >《山海社区公约》</a
                >
              </div>
            </el-form-item>

            <el-form-item
              v-if="isSupplyText"
              key="agree_jiangjie"
              label=""
              prop="checked_jiangjie"
              class="mb-100"
              :rules="[
                { required: true, message: '请同意相关协议' },
                {
                  validator: formRules.isTrue,
                  message: '请同意相关协议',
                  trigger: 'change',
                },
              ]"
            >
              <div class="agree-protocol">
                <el-checkbox class="m-checkbox" @change="handleChangeJiangJieChecked" v-model="formData.checked_jiangjie"
                  >我已阅读并同意</el-checkbox
                ><a
                  class="c-blue"
                  @click="ruleDialogShow=true"
                  >《解说员大赛活动细则&参赛须知》</a
                >
              </div>
            </el-form-item>

            <div class="form-btn-wrap">
              <el-button
                class="m-btn publish"
                type="primary"
                :disabled="posting"
                @click="pubish()"
                >发布</el-button
              >
              <el-button
                class="m-btn normal-blue draft"
                v-if="!isEdit || from == 5"
                :disabled="posting"
                @click="handleSaveDraft()"
                >存草稿</el-button
              >
              <el-button class="m-btn cancel" type="normal" @click="cancel()"
                >取消</el-button
              >
            </div>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 多视频上传 -->
    <div class="video-edit-wrap multiple" v-loading="loading">
      <div v-if="!showVideoSelectWrap && isMultiple">
        <div class="video-type-nav">
          <div class="second-nav-list">
            <a href="/publish" class="item focus"> 发布视频 </a>
            <a href="/video/-1" class="item"> 视频管理 </a>
          </div>
        </div>
        <h2 class="sub-page-title multiple">批量发布</h2>
        <div class="upload-tip">
          <p class="fz-16" v-show="remaining !== 0">
            上传视频中... (剩余{{ remaining }} / {{ fileLength }})
          </p>
          <p class="fz-16" v-show="remaining === 0">
            所有视频上传完成 ({{ fileLength }} / {{ fileLength }})
          </p>
          <p>视频上传完成后将自动存为视频草稿</p>
        </div>
        <el-table :data="fileList" style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="name"
            label="文件名"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="title"
            label="文件标题"
            width="200"
          ></el-table-column>
          <el-table-column label="大小">
            <template slot-scope="{ row }">
              {{ formatSize(row.size) }}
            </template>
          </el-table-column>
          <el-table-column label="进度" width="200">
            <template slot-scope="{ row }">
              <el-progress
                v-if="row.status === 'uploading'"
                :percentage="row.progress"
                :status="row.progress === 100 ? 'success' : undefined"
              ></el-progress>
              <span v-else class="status-tag" :class="row.status">
                {{ statusMap[row.status] }}
                <a v-if="row.status === 'success'" href="/video/5">查看草稿</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      class="preview-dialog"
      title="视频预览"
      :visible.sync="videoPreviewVisible"
      width="70%"
      @close="closePrevideoVideo()"
    >
      <video ref="videoPlayer" class="video" controls autoplay height="450">
        <source :src="videoPlayUrl" />
      </video>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePrevideoVideo()">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      class="rule-dialog"
      title=""
      :visible.sync="ruleDialogShow"
      @close="closeRuleDialog()"
    >
      <div class="rule-content">
        <h4 class="title">"说文解物"全国文博解说员选拔活动协议</h4>
        <div class="inner">
          
          <p class="f-b fz-14">一、活动投稿时间</p>
          <p>即日起-2025年10月12日18：00</p>
          <br/>

          <p class="f-b fz-14">二、活动规则</p>
          <p>活动参加者围绕博物馆、文物、历史名胜古迹等内容进行出镜解说并进行视频投稿，解说内容需尊重文物及历史文化，并符合基本史实。投稿视频将在活动专题页获得曝光展示并积累热度，视频热度榜单中排名较高的参加者将晋级后续活动阶段并赢得奖励。</p>
          <p>·视频投稿要求：</p>
          <p>1.年满16岁及以上的参加者使用本人手机号码登录山海APP，并在“说文解物”全国文博解说员选拔活动专题页进行视频投稿视为成功参加活动。</p>
          <p>2.上传视频时，需提交一段不超过3000字的解说讲稿，文字内容与视频中解说内容一致。</p>
          <p>3.作品要求：围绕博物馆、文物、历史名胜古迹等内容进行3分钟左右的视频解说，视频须包含1分钟以上的本人出镜画面，清晰度达1080P及以上，支持MP4、MOV、AVI、MPEG格式上传，横竖屏不限，画面比例16:9或9:16。</p>
          <p>注：参加活动者须承诺其作品不侵犯任何第三方合法权益（包括但不限于：著作权、商标权、数据权益及其他合法权益等）。若活动过程中发现参与者存在侵权行为或作品存在权利瑕疵，平台方有权取消参与者的参与资格，且参与者需自行承担全部责任。</p>
          <p>·作品初筛规则：</p>
          <p>1.投稿视频将于成功发布起在活动专题页获得曝光展示及15天热度积累机会，将根据互动、播放等数据指标综合计算热度值。视频热度榜单将于8月12日0:00-10月12日18：00在活动专题页进行展示。</p>
          <p>2.活动投稿期间将进行多轮作品初筛：由系统自动筛选当前视频热度榜单排名靠前的参加者，并由平台对其进行资格审定后晋级后续活动阶段，共选出100位参加者晋级；每轮初筛时间间隔将不少于15日，每轮初筛具体时间将提前15日在活动专题页公布，每轮初筛结果将于系统执行热度榜单排名筛选后3个工作日内在活动专题页进行公示。</p>
          <p>3.晋级者资格审定期间，主办方将通过准晋级者登录山海APP所使用的手机号码进行联系并通知后续赛程信息，若审定过程中，出现准晋级者【视频内容不符合基本史实】、【视频内容存在明显谬误】、【视频内容抄袭/侵权】、【存在作弊、刷票行为】、【放弃参加活动】、【无法通过电话进行联系】等情况，或者存在【其他违反平台协议、规则】的情形，将取消其晋级资格，且晋级名额不递延。</p>
          <p>4.活动投稿截止日内，参加者可进行多次投稿，作品初筛仅将参加者热度排名最高的1条投稿视频作为筛选依据，若参加者成功晋级，其投稿作品将不再继续在视频热度榜单中进行展示。</p>
          <br/>

          <p class="f-b fz-14">三、活动进程</p>
          <p>·第一阶段：鲜声夺人！(活动投稿&作品初筛)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;投稿&作品初筛时间：即日起-2025年10月12日18:00
          <p>·第二阶段：解说在线！(线上连麦解说比拼)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;将以多场线上直播连麦的形式进行解说员选拔，最终结合人气值及评委评分选出30位晋级者进入后续活动阶段。</p>
          <p>·第三阶段：声临其境！(博物馆实境解说比拼)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;将邀请晋级者赴博物馆进行命题式文物解说，最终结合人气值及评委评分选出10位晋级者进入后续活动阶段。</p>
          <p>·第四阶段：巅峰争鸣！（演播厅解说比拼）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;活动最终阶段将在湖南省长沙市进行，具体形式将后续在山海APP“说文解物”活动专题页公布</p>
          <p>上述活动进程中第二阶段涉及直播参与活动，须晋级者收到工作人员联系后，在指定直播平台指定直播间参与活动；第三阶段、第四阶段涉及现场参与的，主办方将通过第三方平台为晋级者预定机票、酒店，须晋级者在收到人员联系后提供相关预定信息。</p>
          <br/>
          
          <p class="f-b fz-14">四、活动奖励</p>
          <p>·第一阶段活动奖励（N进100）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;每位晋级者将在成功参与下一阶段活动后获得人民币500元</p>
          <p>·第二阶段活动奖励（100进30）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;每位晋级者将在成功参与下一阶段活动后获得人民币1000元</p>
          <p>·第三阶段活动奖励（30进10）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;每位晋级者将获得参加第四阶段活动的机会</p>
          <p>·第四阶段活动奖励（10强争鸣）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;一等奖（1名）：人民币5万元</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;二等奖（1名）：人民币3万元</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;三等奖（1名）：人民币2万元</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;优秀奖（7名）：人民币1万元</p>
          <p>关于奖金发放：</p>
          <p>1.工作人员将通过获奖者登录山海APP所使用的手机号码进行联系，并在收集到获奖人姓名、银行卡号、身份证号码、开户行信息后30个工作日内，通过银行转账的形式进行奖金发放，若因获奖者填报信息有误，将会造成奖金发放失败，由获奖者自行承担责任。</p> 
          <p>2.若获奖者获奖金额超过500元，需根据获奖金额自行在电子税务局APP内开具个人劳务费发票，项目名称为：劳务-其他劳务，将开具后的发票提交至工作人员联系并指定的芒果问卷，芒果数智将履行代扣代缴义务，按“劳务报酬”为获奖者代扣代缴个税。</p>
          <p>3.芒果数智将按照代扣个税后的实际金额将奖金发放给获奖者。未及时提供收款信息并配合办理税务手续的，视为放弃领奖资格。</p>
          <br/>

          <p class="f-b fz-14">五、活动须知</p>
          <p>1.参加者承诺其获取、提供相应内容及素材用于参与本次活动的行为，不得存在违法法规、违反公序良俗或者违反平台内容审查要求的情形，其提交的任何内容和素材不得侵犯第三方合法权益；</p>
          <p>2.参加者承诺其提供的参加活动内容为自主原创产生，未设定任何权利负担，且将其用于本活动用途及确定其权利归属无需再征得任何第三方同意；</p>
          <p>3.参加者同意：1）参与视频投稿，即视为同意山海平台有权按用户协议及相关平台协议和规则使用其上传内容；2）若其成功晋级初赛，本活动主办方享有一项不可撤销的、基于宣传/运营/商业及非商业化展示等目的而使用其所提交内容的非独占专有许可权利，并有权在使用过程中对相应内容进行适当编辑和处理；若参加者参与活动第一阶段及后续轮次的活动，则活动主办方除对参加者后续提交或展示的内容享有前述第2）项权利外，还有权以直播、录播等方式摄制、传播参加者参与活动的过程及其所提交或展示的内容，且主办方对相关摄制成果享有独占专有的知识产权，有权在行使其权利过程中使用参加者的姓名、声音、肖像等人身元素。4）主办方按前述约定使用相关内容或成果，仅需按本协议约定方式发放活动奖励，无需在征得参加者同意或另行支付报酬。</p>
          <br/>
          
          <p class="f-b fz-14">六、法律声明</p>
          <p class="f-b">协议双方</p>
          <p>1.“说文解物”全国文博解说员选拔活动(以下简称“活动”)面向全社会开放，年满16岁、具备博物馆、文物历史及中华传统文化知识素养，热爱文博解说的人员均可进行视频投稿参加本次活动。</p>
          <p>2.活动由湖南芒果数智艺术科技有限责任公司(简称“主办方”或“山海平台”)组织。</p>
          <p class="f-b">协议的解释与补充</p>
          <p>1.本协议基于《山海用户服务协议》《山海个人信息保护政策》以及山海平台相关规则制定，本协议未尽事宜，应按照前述平台协议或规则进行理解、解释与执行。</p>
          <p>2.山海平台上出现的相关操作提示或我们以其他方式向您展示的规则、流程、公告及通知亦是本协议的一部分。您在参与活动时，应遵守前述平台指引的要求。</p>
          <p>3.在法律允许范围内，山海平台对本协议及相关活动享有解释权。</p>
          <p class="f-b">未成年人保护的特别约定</p>
          <p>1.若活动参与者为未成年人，应在监护人指导及同意下阅读本活动协议及参与相关活动。若监护人同意未成年人参与本活动，应对其进行正确引导、监督。未成年人参与本活动，即视为已经取得其监护人的同意。</p>
          <p>2.若未成年人取得参与第二阶段及之后阶段活动的资格，应按主办方工作人员的要求提供监护人同意其参与活动的书面确认文件及相关凭证，未能及时配合提供相关文件和凭证的视为放弃后续阶段活动的参与资格。</p>
          <p class="f-b">条款的确认与接受</p>
          <p>1.您(以下简称“参加者”)自愿报名参加“说文解物”全国文博解说员选拔活动(以下简称“活动”)，在点击页面上【同意上述规则，立即投稿】按钮之前，请务必仔细阅读并充分理解《“说文解物”全国文博解说员选拔活动协议》(简称“本协议”)的内容，特别是以粗体标注的条款。</p>
          <p>2.如果参加者不同意本协议的任何内容，或者无法准确理解某项条款，请不要进行视频投稿。主办方接受任何疑问咨询、建议，并将解释本协议内容，通讯方式已公布于本次活动的官方网站。如您有任何疑问，请及时联系平台客服。</p>
          <p>3.参加者应知晓，点击本页面【同意活动协议，立即投稿】按钮或者实际参加本活动任一阶段，即代表参加者已接受并签署了本协议的全部条款和内容，同意受到本协议约束。参加者不应以未阅读本协议的内容或者未获得主办方问询及解答等理由，主张本协议无效或要求撤销、解除、终止本协议。</p>
        </div>
        <div class="button" @click="closeRuleDialog()"></div>
      </div>
      <!-- <el-button @click="closeRuleDialog()">关闭</el-button> -->
    </el-dialog>
  </div>
</template>

<script>
/*eslint-disable*/
import Header from '@/components/Header.vue';
import SideBar from '@/components/SideBar.vue';
import ImgCropUpload from '@/components/ImgCropUpload';
import ContentTagSelect from '@/components/ContentTagSelect.vue';
import TopicSelect from '@/components/TopicSelect.vue';
import {
  uploadGetStsToken,
  getVideoCover,
  publish,
  editFeed,
  getVideoDetail,
  saveDraft,
  editDraft,
  getActivityList,
  getCollectList,
  getDraftDetail,
  publishDraft,
  getTopicList,
  getUserInfo,
} from '@/servies/index.js';

// publishDraft
import {
  getFileBase64By64Bytes,
  getFileExtension,
  calculateMD5Binary,
  calculateMD5Base64,
  fileUpload,
} from '@/utils/upload';

export default {
  data() {
    return {
      ruleDialogShow: false,
      isSupplyText: false,
      htmlStr: '',
      totolTxtNum: 500,
      contentLen: 0,
      overLimit: false,
      lastSelection: null,
      allowedFormats: [
        'video/mp4',
        'video/mov',
        'video/quicktime',
        'video/avi',
      ],
      fileAccept: 'video/quicktime, video/mov, video/avi, .mov,.mp4,.avi',
      UPLOAD_BATCH_SIZE: 5,
      MAX_SIZE_NUMBER: 5,
      MAX_SIZE: 5 * 1024 * 1024 * 1024,
      isMultiple: false,
      isEdit: false,
      from: '',
      readMultiple: false,
      fileList: [],
      statusMap: {
        waiting: '等待上传',
        uploading: '上传中',
        success: '上传成功',
        error: '上传失败',
      },
      videoPreviewVisible: false,
      videoPlayUrl: '',
      activityList: [],
      topicList: [],
      collectionList: [],
      posting: false,
      loading: false,
      snapshotVideoList: [],
      idStrVideo: '',
      idStrIamge: '',
      formData: {
        feedType: 4,
        fileName: '',
        checked: false,
        videoId: '',
        title: '',
        content: '',
        crossImg: '',
        verticalImg: '',
        fileId: '',
        videoUrl: '',
        activityId: '',
        collectionIds: '',
        contentTags: [],
        topics: [],
        videoInfo: {},
        topicList: [],
        isUseAI: 0,
      },
      hideUploadNeedTime: false,
      uploadProgressPercent: 0,
      uploadNeedTime: 0,
      uploadStatusText: '',
      uploadFile: {
        name: 'test',
      },
      userInfo: null,
      showVideoSelectWrap: true,
      videoId: '',
    };
  },
  components: {
    Header,
    SideBar,
    ImgCropUpload,
    ContentTagSelect,
    TopicSelect,
  },
  computed: {
    remaining() {
      return this.fileList.filter(
        (file) => !['success', 'error'].includes(file.status)
      ).length;
    },
    fileLength() {
      return this.fileList.length;
    },
  },
  created () {
    this.checkUserStatus()
    this.fetchActive();
    const vid = this.$route.params.vid;
    // 来源 5草稿  3未通过
    const from = this.$route.params.status;
    if (vid) {
      this.videoId = vid;
      this.from = from;
      this.showVideoSelectWrap = false;
      this.isEdit = true;
      if (from == 5) {
        this.fetchDraftDetail();
      } else {
        this.fetchDetail();
      }
    }
  },

  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem('sh-userInfo'));
    this.fetchTopic();
    this.fetchCollection('文');
  },
  methods: {
    checkUserStatus () {
      getUserInfo({}).then((response) => {
        if (
          response.data.code === 200 &&
          response.data.data
        ) {
          console.log('已登录')
        } else {
          this.$message({
            message: response.data.msg,
            type: 'error',
          });
          setTimeout(() => {
            this.$utils.clearLoginUserCookie();
            window.location.href = '/login';
          }, 1000);
        }
      }).catch((error) => {
        // 这里能捕获 402、404、500 等所有非 2xx 的 HTTP 错误
        if (error.response) {
          // 服务器有响应，error.response.status 就是状态码
          this.$message({
            message: error.response.data.msg,
            type: 'error',
          });
          setTimeout(() => {
            this.$utils.clearLoginUserCookie();
            window.location.href = '/login';
          }, 1000);
        } else {
          // 服务器无响应或网络错误
          this.$message({
            message: '网络异常或服务器无响应',
            type: 'error',
          });
          setTimeout(() => {
            this.$utils.clearLoginUserCookie();
            window.location.href = '/login';
          }, 1000);
        }
        console.error(error);
      });
    },
    handleChangeJiangJieChecked (value) {
      if (value) {
        this.ruleDialogShow = true
      }
    },
    checkIsFLV(filename) {
      const ext = filename.split('.').pop().toLowerCase();
      return ['.flv', '.FLV'].includes(`.${ext}`);
    },
    getStringLength(str) {
      const temp = str;
      const strippedText = $utils.filterHTML(temp);
      const textlength = strippedText.length;
      this.contentLen = textlength;
      this.overLimit = false;
      if (textlength > this.totolTxtNum) {
        this.overLimit = true;
        this.$message({
          message: '输入内容超过建议长度，请注意',
          type: 'error',
        });
      }
    },
    saveSelection() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        this.lastSelection = selection.getRangeAt(0).cloneRange(); // 克隆 Range 避免引用问题
      }
    },
    handleOnBlur() {
      this.saveSelection();
    },
    handleInput() {
      this.saveSelection();
      this.getStringLength(this.$refs.editRef.innerHTML);
    },
    insertPublishTopic(topic) {
      const editor = this.$refs.editRef;
      const range = $utils.insertTopicChip(
        editor,
        topic && topic.topicName,
        this.lastSelection
      );
      if (!editor || !range) return;
      this.lastSelection = range;
      this.getStringLength(editor.innerHTML);
    },
    handleSelectActive(value) {
      const selectedOption = this.activityList.find(
        (option) => option.id === value
      );
      const isTickUseAI = selectedOption?.isTickUseAI;
      this.formData.isUseAI = isTickUseAI === 1 ? true : false;

      const isSupplyText = selectedOption?.isSupplyText;
      this.isSupplyText = isSupplyText === 1 ? true : false
    },
    fetchActive() {
      getActivityList({}).then((response) => {
        if (
          response.data.code === 200 &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          this.activityList = response.data.data;
        }
      });
    },
    fetchTopic() {
      getTopicList({}).then((response) => {
        if (
          response.data.code === 200 &&
          response.data.data.contents &&
          response.data.data.contents.length > 0
        ) {
          this.topicList = response.data.data.contents;
          if (
            this.videoDetail &&
            (!this.formData.topics || !this.formData.topics.length)
          ) {
            this.formData.topics = $utils.topicsFromFeed(
              this.videoDetail,
              this.topicList
            );
          }
        }
      });
    },
    onCollectionVisible(visible) {
      if (visible && !this.collectionList.length) this.fetchCollection('文');
    },
    fetchCollection(query) {
      const keyword = query || '文';
      getCollectList({ q: keyword, did: this.$utils.getSTKUUID() }).then(
        (res) => {
          let response = res.data;
          if (
            response.code === 200 &&
            response.data &&
            response.data.contents &&
            response.data.contents.length > 0
          ) {
            this.collectionList = response.data.contents;
          }
        }
      );
    },
    closeRuleDialog () {
      this.ruleDialogShow = false
    },
    closePrevideoVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause(); // 暂停视频
      }
      this.videoPreviewVisible = false;
    },
    previewVideo() {
      this.videoPlayUrl = this.formData?.videoResp?.videoTmpUrl;
      this.videoPreviewVisible = true;
    },
    handleSaveDraft() {
      if (this.videoUploading) {
        this.$message({
          message: '请等待视频上传完成！',
          type: 'warning',
        });
        return;
      }
      if (this.posting) return;
      const editingDraft = this.isEdit && this.from == 5;
      const fileId = editingDraft
        ? this.formData.videoResp?.videoParam?.fileId
        : this.idStrVideo;
      const fileName = editingDraft
        ? this.formData.videoResp?.videoParam?.fileName
        : this.formData.fileName;
      if (!fileId) {
        this.$message({
          message: '视频信息还在加载，请稍后再保存',
          type: 'warning',
        });
        return;
      }
      this.posting = true;
      const data = {
        isUseAI: this.formData.isUseAI ? 1 : 0,
        activityId: this.formData.activityId,
        collectionIds:
          this.formData.collectionIds === '' ||
          this.formData.collectionIds === undefined
            ? ''
            : this.formData.collectionIds.join(','),
        content: this.$refs.editRef.innerText,
        title: this.formData.title,
        supplyText: this.formData.supplyText,
        topicIds: $utils.formatTopicIds(this.formData.topics),
        tagIds: $utils.formatContentTagIds(this.formData.contentTags),
        videoInfo: {
          fileId,
          fileName,
        },
      };
      if (!editingDraft) data.feedType = 4;
      if (editingDraft) data.id = String(this.formData.id);
      if (data.topicIds === null) delete data.topicIds;
      if (data.activityId === '') delete data.activityId;
      if (data.collectionIds === '' || data.collectionIds.length === 0)
        delete data.collectionIds;
      if (this.idStrIamge) {
        data.videoInfo.videoCover = {
          imgHeight: 478,
          imgWidth: 342,
          imgType: 10,
          imgID: this.idStrIamge,
        };
      } else if (editingDraft) {
        const existingCover = this.formData.videoResp?.videoParam?.videoCover;
        if (existingCover && existingCover.imgID && existingCover.imgID !== '0') {
          data.videoInfo.videoCover = {
            imgID: existingCover.imgID,
            imgType: existingCover.imgType,
            imgHeight: existingCover.imgHeight,
            imgWidth: existingCover.imgWidth,
          };
        }
      }
      const request = editingDraft ? editDraft(data) : saveDraft(data);
      request
        .then((response) => {
          const { code, msg } = response.data;
          if (code === 200) {
            this.$message({
              message: '保存成功',
              type: 'success',
            });
            this.$router.replace('/video/5');
          } else {
            this.$message({
              message: msg,
              type: 'error',
            });
          }
          this.posting = false;
        })
        .catch(() => {
          this.posting = false;
          this.$message({
            message: '保存失败，请稍后重试',
            type: 'error',
          });
        });
    },
    fetchDetail() {
      getVideoDetail({
        id: this.videoId,
      }).then((res) => {
        let response = res.data;
        if (response.code == 200 && response.data.contents.length > 0) {
          this.videoDetail = response.data.contents[0];
          this.setDetailData(this.videoDetail);
        }
      });
    },
    fetchDraftDetail() {
      getDraftDetail({
        id: this.videoId,
      }).then((res) => {
        let response = res.data;
        if (response.code == 200 && response.data) {
          this.videoDetail = response.data;
          if (response.data.activityId) {
            const selectedOption = this.activityList.find(
              (option) => option.id === response.data.activityId
            );
            const isSupplyText = selectedOption?.isSupplyText;
            this.isSupplyText = isSupplyText === 1 ? true : false
          }
          this.getVideoSnapshot(response.data.videoResp.videoParam.fileId);
          this.setDetailData(this.videoDetail);
        }
      });
    },
    setDetailData(feedInfo) {
      let data = {
        content: feedInfo.content,
        isUseAI: feedInfo.isUseAI === 1 || feedInfo.isUseAI === true,
        verticalImg: feedInfo.videoResp?.videoCover,
        collectionIds:
          feedInfo.collectionIds !== ''
            ? feedInfo.collectionIds?.split(',')
            : [],
        contentTags: $utils.normalizeContentTags(feedInfo.contentTags),
        topics: $utils.topicsFromFeed(feedInfo, this.topicList),
        activityId:
          feedInfo.activityId === 0 ||
          feedInfo.activityId === '0' ||
          !feedInfo.activityId
            ? ''
            : feedInfo.activityId,
      };
      this.formData = { ...feedInfo, ...data };
      this.htmlStr = $utils.formatTopic(feedInfo.content);
      this.getStringLength(feedInfo.content);
    },
    uploadVideoFileChange() {
      const fileInput = this.$refs.uploadVideoInput,
        videoFile = fileInput.files[0];
      if (videoFile) {
        this.onVideoFileSelected(videoFile, 1, true);
      }
    },
    handleBeforeUpload(file) {
      console.log('handleBeforeUpload');
      file.url = URL.createObjectURL(file.raw);
      return true;
    },
    // 有文件被选
    onVideoFileSelected(file, rawFiles = [], repair) {
      if (!file) return;
      this.loading = true;
      setTimeout(() => {
        if (rawFiles.length > 1) {
          if (this.readMultiple) return;
          this.fileList = [];
          this.multipleUpload(rawFiles);
          this.readMultiple = true;
        } else {
          this.uploadVideoHandle(file, repair);
        }
      }, 200);
    },
    async uploadVideoHandle(file, repair = false) {
      if (!file) return;

      const videoFile = file;
      const validFiles = this.isValidFile(file);

      if (validFiles) {
        this.uploadFile = videoFile;

        if (repair) {
          this.uploadProgressPercent = 0;
        }

        // 默认取文件名当标题
        let fileName = videoFile.name;
        if (videoFile.name.indexOf('.') >= 0) {
          const i = videoFile.name.lastIndexOf('.');
          fileName = videoFile.name.substr(0, i);
        }
        this.formData.title = fileName;
        this.formData.fileName = videoFile.name;

        let requestFile = videoFile;
        if (videoFile.raw) requestFile = videoFile.raw;

        const base64 = await getFileBase64By64Bytes(requestFile);
        const fileExtension = getFileExtension(videoFile.name);
        console.log(fileExtension);
        try {
          const binaryHash = calculateMD5Binary(requestFile);
          uploadGetStsToken({
            fileHeadBase64: base64,
            fileSize: requestFile.size,
            fileSubfix: fileExtension,
            fileContentMd5: calculateMD5Base64(binaryHash),
          }).then((res) => {
            const { code } = res.data;
            if (code === 200) {
              const token = res.data.data;
              this.idStrVideo = token.keyInfo.idstr;
              this.showVideoSelectWrap = false;
              this.videoUploading = true;
              this.uploadStatusText = '上传中...';
              this.loading = false;
              fileUpload(
                token,
                requestFile,
                (percent) => {
                  console.log(`上传进度监听>>>${percent}`);

                  this.uploadProgressPercent = percent;
                },
                (success) => {
                  console.log(success);
                  this.videoUploading = false;
                  this.uploadStatusText = '上传成功';
                  this.getVideoSnapshot(token.keyInfo.idstr);
                  console.log('视频上传成功');
                },
                (error) => {
                  this.videoUploading = false;
                  this.showVideoSelectWrap = true;
                  this.loading = false;
                  this.$message({
                    message: '视频上传失败，请稍后重试',
                    type: 'error',
                  });
                }
              );
            } else {
              this.videoUploading = false;
              this.showVideoSelectWrap = true;
              this.loading = false;
              this.$message({
                message: '签名获取失败，视频未上传成功，请稍后重试',
                type: 'error',
              });
            }
          }).catch((error) => {
            this.videoUploading = false;
            this.showVideoSelectWrap = true;
            this.loading = false;
            this.$message({
              message: '签名获取失败，视频未上传成功，请稍后重试',
              type: 'error',
            });
          });
        } catch (e) {
          this.videoUploading = false;
          this.showVideoSelectWrap = true;
          this.$message({
            message: '签名获取失败，视频未上传成功，请稍后重试',
            type: 'error',
          });
        }
      } else {
        this.loading = false;
      }
    },
    multipleUpload(rawFiles) {
      const validFiles = rawFiles.filter((f) => this.isValidFile(f));
      // 没有符合条件的数据
      if (validFiles.length === 0) {
        this.loading = false;
        return;
      }

      // 更新文件列表
      this.fileList = validFiles.map((f) => ({
        raw: f.raw,
        name: f.name,
        size: f.size,
        progress: 0,
        feedType: 4,
        status: 'waiting',
        title: '',
        videoInfo: {
          fileId: '',
          fileName: f.name,
        },
      }));
      this.uploadMultiple();
    },
    async uploadMultiple() {
      this.loading = false;
      this.isMultiple = true;
      this.showVideoSelectWrap = false;
      const pending = this.fileList.filter(
        (file) => file.status === 'waiting' || file.status === 'error'
      );
      for (let i = 0; i < pending.length; i += this.UPLOAD_BATCH_SIZE) {
        const batch = pending.slice(i, i + this.UPLOAD_BATCH_SIZE);
        await Promise.all(batch.map((file) => this.uploadQueuedFile(file)));
      }
    },
    uploadQueuedFile(file) {
      return new Promise((resolve) => {
        const fail = (message) => {
          file.status = 'error';
          this.$message({
            message,
            type: 'error',
          });
          resolve();
        };
        file.status = 'uploading';
        file.progress = 0;
        let fileName = file.name;
        if (file.name.indexOf('.') >= 0) {
          const i = file.name.lastIndexOf('.');
          fileName = file.name.substr(0, i);
        }
        file.title = fileName;
        const requestFile = file.raw || file;
        getFileBase64By64Bytes(requestFile)
          .then((base64) => {
            const binaryHash = calculateMD5Binary(requestFile);
            return uploadGetStsToken({
              fileHeadBase64: base64,
              fileSize: requestFile.size,
              fileSubfix: getFileExtension(file.name),
              fileContentMd5: calculateMD5Base64(binaryHash),
            });
          })
          .then((res) => {
            if (res.data.code !== 200) {
              fail('签名获取失败，视频未上传成功，请稍后重试');
              return;
            }
            const token = res.data.data;
            file.videoInfo.fileId = token.keyInfo.idstr;
            fileUpload(
              token,
              requestFile,
              (percent) => {
                file.progress = percent;
              },
              () => {
                file.status = 'success';
                saveDraft({
                  title: file.title,
                  feedType: 4,
                  videoInfo: file.videoInfo,
                });
                resolve();
              },
              () => {
                fail('视频上传失败，请稍后重试');
              }
            );
          })
          .catch(() => {
            fail('视频上传失败，请稍后重试');
          });
      });
    },
    formatSize(size) {
      const units = ['B', 'KB', 'MB', 'GB'];
      let i = 0;
      while (size >= 1024 && i < units.length - 1) {
        size /= 1024;
        i++;
      }
      return `${size.toFixed(2)} ${units[i]}`;
    },
    imgUploadSuccess(data, target) {
      this.idStrIamge = data.idStrImage;
      this.formData[target] = data.url;
    },
    getVideoSnapshot(fileId) {
      this.snapshotVideoList = [];
      getVideoCover({
        fileId,
      }).then((response) => {
        const { code, data } = response.data;
        if (code == 200) {
          this.snapshotVideoList = data.covers;
        } else {
          this.$message({
            message: '自动截取视频封面失败，请选择本地上传',
            type: 'error',
          });
          this.snapshotVideoList = [];
        }
      });
    },
    pubish() {
      if (this.videoUploading) {
        this.$message({
          message: '请等待视频上传完成！',
          type: 'warning',
        });
        return;
      }
      if (this.overLimit) {
        this.$message({
          message: '输入内容超过建议长度，请注意',
          type: 'error',
        });
        return;
      }
      this.$refs.formDom.validate((valid) => {
        if (valid) {
          this.submitData();
        } else {
          this.$message({
            message: '数据填写不符合规范！',
            type: 'error',
          });
          return false;
        }
      });
    },
    submitData() {
      if (this.posting) return;
      this.posting = true;
      let data = {
        isUseAI: this.formData.isUseAI ? 1 : 0,
        activityId: this.formData.activityId,
        collectionIds:
          this.formData.collectionIds === '' ||
          this.formData.collectionIds === undefined
            ? ''
            : this.formData.collectionIds.join(','),
        content: this.$refs.editRef.innerText,
        feedType: 4,
        title: this.formData.title,
        supplyText: this.formData.supplyText,
        topicIds: $utils.formatTopicIds(this.formData.topics),
        tagIds: $utils.formatContentTagIds(this.formData.contentTags),
      };

      if (data.activityId === '') delete data.activityId;
      if (data.collectionIds === '' || data.collectionIds.length === 0)
        delete data.collectionIds;
      if (data.topicIds === null) delete data.topicIds;

      // 编辑草稿和审核通过的帖子
      if (this.isEdit) {
        data.videoInfo = {};
        if (this.idStrIamge) {
          data.videoInfo.videoCover = {
            imgHeight: 478,
            imgWidth: 342,
            imgType: 10,
            imgID: this.idStrIamge,
          };
        }
      }
      if (this.from == 5 && this.isEdit) {
        data.feedDraftId = this.formData.id;
        data.videoInfo.fileId = this.formData.videoResp.videoParam.fileId;
        data.videoInfo.fileName = this.formData.videoResp.videoParam.fileName;
        publishDraft(data).then((response) => {
          const { code, msg } = response.data;
          if (code === 200) {
            let msg = '发布成功，正在审核';
            this.$message({
              message: msg,
              type: 'success',
            });
            // 跳审核中
            this.$router.replace('/video/2');
          } else {
            this.$message({
              message: msg,
              type: 'error',
            });
          }
          this.posting = false;
        });
      } else if (this.from !== 5 && this.isEdit) {
        data.feedId = this.formData.id;
        editFeed(data).then((response) => {
          const { code, msg } = response.data;
          if (code === 200) {
            let msg = '发布成功，正在审核';
            this.$message({
              message: msg,
              type: 'success',
            });
            // 跳审核中
            this.$router.replace('/video/2');
          } else {
            this.$message({
              message: msg,
              type: 'error',
            });
          }
          this.posting = false;
        });
      } else {
        data.videoInfo = {
          fileId: this.idStrVideo,
          fileName: this.formData.fileName,
          videoCover: {
            imgHeight: 478,
            imgWidth: 342,
            imgType: 10,
            imgID: this.idStrIamge,
          },
        };
        publish(data).then((response) => {
          const { code, msg } = response.data;
          if (code === 200) {
            let msg = '发布成功，正在审核';
            this.$message({
              message: msg,
              type: 'success',
            });
            this.$router.replace('/video/2');
          } else {
            this.$message({
              message: msg,
              type: 'error',
            });
          }
          this.posting = false;
        });
      }
    },
    cancel() {
      this.$confirm(``, '确定放弃编辑？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
      }).then(async () => {
        this.$router.replace(`/video/${this.from}`);
      });
    },
    isValidFile(file) {
      if (file.raw) file = file.raw;
      console.log('文件格式>>>>> ' + file.type);
      // const isFLV = this.checkIsFLV(file.name)
      // flv文件格式在windows下没有file.type，所以这里排除掉flv格式吧
      const isAllowedFormat = this.allowedFormats.includes(file.type);
      const isLt2G = file.size <= this.MAX_SIZE;
      if (!isAllowedFormat) {
        this.$message.error(`文件 ${file.name} 格式不支持，请重新选择`);
      }
      if (!isLt2G) {
        this.$message.error(
          `文件 ${file.name} 大小超过${this.MAX_SIZE_NUMBER}GB`
        );
      }
      return isAllowedFormat && isLt2G;
    },
  },
  watch: {},
};
</script>

<style lang="less">
.pub-video-page {
  height: 100vh;
  width: 100%;
  padding-top: 64px;
  .content {
    display: flex;
    .right {
      margin-left: 60px;
    }
  }
  // overflow: hidden;
  // 文件选择
  .video-upload-select-wrap {
    width: 1280px;
    height: calc(100% - 200px);
    min-height: 400px;
    margin: 60px auto 0;
    padding-bottom: 100px;
    .video-uploader-box {
      height: 100%;
      width: 100%;
      border-radius: 30px;
      margin-top: 20px;
      .m-uploader {
        width: 100%;
        height: 100%;
        .el-upload {
          width: 100%;
          height: 100%;
        }
      }
      .el-upload-dragger {
        width: 100%;
        height: 100%;
        position: relative;
        border: 1px dashed #d9d9d9;
        background: #f2f3f9;
        border-width: 2px;
        border-radius: 29px;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
        .el-icon-upload {
          margin-top: -120px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 150px;
          color: #ccced2;
        }
        .el-upload__text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 18px;
          color: #93939d;
          .multi-tip {
            font-size: 15px;
            color: #b4b5bc;
          }
        }
        .upload-btn {
          background: #04cbcd;
          border-radius: 24px;
          font-size: 16px;
          padding: 0 38px;
          line-height: 48px;
          height: 48px;
          border: 0;
          color: #fff;
          display: block;
          margin: 0 auto;
          height: 44px;
          line-height: 44px;
          margin-top: 30px;
          &:hover {
            opacity: 0.9;
          }
        }
        &:hover {
          border-color: #04cbcd;
        }
      }
    }

    .video-upload-tips {
      padding-top: 40px;
      display: flex;
      justify-content: space-between;
      li {
        display: inline-block;
        width: 22%;
        text-align: center;
        .icon {
          color: #e3e4ec;
          vertical-align: middle;
          font-size: 45px;
          fill: #e3e4ec;
        }
        span {
          display: inline-block;
          color: #333333;
          font-size: 18px;
          vertical-align: middle;
          text-align: left;
          padding-left: 10px;
          i {
            padding-top: 4px;
            display: block;
            font-style: normal;
            color: #93939d;
            font-size: 14px;
          }
        }
      }
    }
  }
  // 视频编辑
  .video-edit-wrap {
    width: 1280px;
    margin: 60px auto 0;
    .sub-page-title {
      width: 100%;
      margin: 20px auto 20px;
      &.multiple {
        width: 1280px;
      }
    }
    .upload-tip {
      height: 20px;
      color: #888;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .video-edit-module {
      width: 898px;
      margin: 40px auto 0;
      &.preview-module {
        .m-title {
          margin-bottom: 10px;
        }
        .preview-warp {
          width: 200px;
          height: 112px;
          cursor: pointer;
          position: relative;
          border-radius: 4px;
          img {
            width: 200px;
            height: 112px;
            border-radius: 4px;
            position: absolute;
            z-index: 1;
          }
          .mask {
            width: 200px;
            height: 112px;
            border-radius: 4px;
            background: #000;
            opacity: 0.5;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
          }
          .play-icon {
            width: 40px;
            height: 40px;
            background: url('@/assets/images/play-icon.png') no-repeat;
            background-size: 40px 40px;
            position: absolute;
            z-index: 3;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      &:first-child {
        margin-top: 0;
      }
      .m-title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
      }
      .m-ctnt {
        padding: 20px 0;
        &.pb0 {
          padding-bottom: 0;
        }
      }
    }
    .line {
      max-width: 820px;
      height: 0;
      border-top: 1px solid #f3f3f9;
    }

    .video-upload-progress {
      border: 2px dashed #e2e2ec;
      border-radius: 29px;
      padding: 40px 60px;
      position: relative;
      font-size: 14px;
      .video-name {
        display: block;
        color: #333333;
        font-size: 16px;
        height: 22px;
        width: 80%;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .progress-info {
        position: absolute;
        top: 45px;
        right: 60px;
        i {
          font-style: normal;
        }
        .percent {
          color: #333333;
        }
        .time {
          padding-left: 10px;
          color: #93939d;
        }
      }
      .progress-box {
        height: 14px;
        background: #e9ecf3;
        border-radius: 7px;
        margin: 16px 0;
        .progress-bar {
          height: 100%;
          background: #04cbcd;
          border-radius: 7px;
        }
      }
      .other-info {
        .status-text {
          color: #93939d;
        }
        .upload-text-btn {
          width: 62px;
          height: 22px;
          position: absolute;
          display: block;
          right: 60px;
          bottom: 40px;
          label {
            width: 100%;
            height: 100%;
            display: block;
            line-height: 22px;
            text-align: center;
            cursor: pointer;
            position: relative;
            z-index: 2;
            color: #04cbcd;
            &:hover {
              opacity: 0.8;
            }
          }
          input {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
            clip: rect(0px, 0px, 0px, 0px);
          }
        }
      }
    }

    .online-timer {
      height: 50px;
      display: inline-flex;
      vertical-align: middle;
      width: 300px;
      margin-left: 10px;
    }
    //
    .upload-img-item {
      .upload-img-wrap {
        height: 144px;
        &.cross {
          width: 255px;
        }
        &.vertical {
          width: 92px;
        }
      }
      .tip-text {
        color: #93939d;
        line-height: 24px;
        display: block;
        font-size: 12px;
        &.mt6 {
          margin-top: 6px;
        }
        i {
          font-style: normal;
          color: #333;
        }
      }
    }

    .class-id {
      /deep/ .el-form-item__error {
        top: 50px;
      }
    }


    .form-btn-wrap {
      margin-top: 30px;
      padding-bottom: 50px;
      .m-btn{
        background: #04CBCD;
        color: #fff;
        border-radius: 24px;
        font-size: 16px;
        padding: 0 38px;
        line-height: 48px;
        height: 48px;
        border: 0;
        &.publish{
          &:hover{
            opacity: 0.9;
          }
        }

        &.draft{
          background: #f3f3f9;
          color: #04CBCD;
          &:hover{
            background: #04CBCD;
            color: #fff;
          }
        }
        &.cancel{
          background: #f3f3f9;
          color: #333;
          &:hover{
            opacity: 0.8;
          }
        }
      }
    }

    .plan-lists {
      .plan-popover {
        display: inline-block;
        height: 42px;
        margin: 0 15px 15px 0;
      }
      .plan-item {
        display: inline-block;
        height: 42px;
        line-height: 42px;
        padding: 0 18px;
        min-width: 140px;
        text-align: center;
        cursor: pointer;
        background: #f3f3f9;
        color: #666;
        border-radius: 20px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .detail-link {
          padding: 3px;
          margin-left: 5px;
          color: #666;
          cursor: pointer;
          &:hover {
            color: #ddd;
          }
          .icon {
            font-size: 16px;
            vertical-align: -0.2em;
          }
        }
        &:hover {
          opacity: 0.8;
          background: #04cbcd;
          color: #fff;
          .detail-link {
            color: #fff;
          }
        }
        &.on {
          background: #04cbcd;
          color: #fff;
          opacity: 1;
          .detail-link {
            color: #fff;
          }
        }
      }
    }
    .jump-link {
      color: blue;
    }

 
  }
  // 关联文物样式
  .collection-form-item {
    .el-form-item__content {
      .el-select {
        width: 400px;
        .el-input__inner {
          border-radius: 5px !important;
        }
        .el-input .el-select__caret::before {
          content: "\e6e1";
        }
        .el-input.is-focus .el-select__caret {
          transform: rotateZ(0deg);
        }
      }
    }
  }
}
.rule-dialog{
  width: 1084px;
  height: 751px;
  background: url('@/assets/images/rule-dialog-bg.png') no-repeat;
  background-size: 1084px 751px;
  left: 50%;
  margin-left: -542px;
  top: 50%;
  margin-top: -375px;
  overflow: hidden;
  .el-dialog{
    margin: 0 auto !important;
    background: none;
    width: 100%;
    .el-dialog__header{
      .el-icon-close{
        width: 50px;
        height: 50px;
        background: url('@/assets/images/rule-dialog-close.png') no-repeat;
        background-size: 50px 50x;
        &:before {
          content: none;
        }
        &:hover{
          opacity: 0.9;
        }
      }
    }
    .el-dialog__body{
      padding: 0 20px;
      .rule-content{
        width: 948px;
        height: 517px;
        margin: 204px auto 0;
        .title{
          height: 68px;
          text-align: center;
          font-size: 20px;
          padding-top: 20px;
          color: #fff;
        }
        .inner{
          width: 928px;
          color: #fff;
          font-size: 12px;
          padding: 0 30px;
          height: 327px;
          overflow-y: scroll;
          &::-webkit-scrollbar {
            width: 5px;  /* 垂直滚动条宽度 */
            height: 5px; /* 水平滚动条高度 */
          }
          /* 滚动条轨道 */
          &::-webkit-scrollbar-track {
            background: #401E06;
            border-radius: 2.5px;
          }
          /* 滚动条滑块 */
          &::-webkit-scrollbar-thumb {
            background: #9E5929 ;
            border-radius: 2.5px;
          }
        }
        .button{
          margin: 10px auto 0;
          width: 372px;
          height: 50px;
          background: url('@/assets/images/rule-dialog-btn.png') no-repeat;
          background-size: 372px 50x;
          cursor: pointer;
        }
      }
    }

  }
}
</style>
